





























































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
/* component */
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
/* api */
import MypagePasswordApi from '@/app/model/api/mypagePasswordApi'
import MypagePutKeyApi from '@/app/model/api/mypagePutKeyApi'
import MypageGetKeyApi from '@/app/model/api/mypageGetKeyApi'
import UploadLinkImgApi from '@/app/model/api/uploadLinkImgApi'
import GetLinkImgApi from '@/app/model/api/getLinkImgApi'
import LinkImgDeleteApi from '@/app/model/api/LinkImgDeleteApi'
/* module */
import Validator from '@/app/module/validator'
import CommonClass from '@/app/module/common'
import Local from '@/app/module/local'
import { userType } from '@/app/model/store/domain/const'
import ServiceFunctionApi from '@/app/model/api/serviceFunctionApi'
import ServiceFunctionEditApi from '@/app/model/api/serviceFunctionEditApi'

@Component({
  components: {
    DeleteModal,
    ErrorInfo,
    ConfirmModal,
    Loading
  }
})
export default class extends Vue {
  private currentPassword: string = ''
  private newPassword: string = ''
  private confirmNewPassword: string = ''
  private errorMessages: {[key: string]: string} = {}
  private show400ModalErrorMessage: boolean = false
  private alertText: string = ''
  private alertTitle: string = ''
  private apiKey: string = ''
  private apiKeyDate: any = ''
  private companyApiKeyInfo: boolean = false
  private keyData: any = {}
  private isValid: number = 0
  private file: any = {}
  private linkImg: any = ''
  private isLinkImg: boolean = false
  private deleteKey: string = ''
  private confirmMessage: string = '<p>外部APIキーを更新します。よろしいですか？</p><p class="caution">※以前のAPIキーは利用できなくなります。</p>'
  /* 表示非表示 */
  private showApiKey: boolean = false
  private showEditModal: boolean = false
  private showDeleteModal: boolean = false
  private showKeyEditModal: boolean = false
  private showLinkImg: boolean = false
  private showLinkImgLoading: boolean = false
  private serviceFunctionData: any = {
    news_board: {
      news_board_name: '栽培指導広報'
    },
    external_link: {
      external_link_name: '外部連携'
    }
  }
  private isAdmin: boolean = false

  @Prop() private userData!: any

  created () {
    if (Local.getUserType() === String(userType.USER_TYPE_ADMIN)) {
      this.getApiKeyData()
      this.getServiceFunctionData()
      this.companyApiKeyInfo = true
      this.showLinkImg = true
      this.getDefaultImg()
      this.isAdmin = true
    } else {
      this.$store.commit('setFlagState/setMyApiKeyFlag', false)
    }
  }

  /* 更新モーダル表示 */
  private doEditApikey () {
    this.showKeyEditModal = true
  }

  /* APIキー生成 */
  private displayApiKey () {
    this.showKeyEditModal = false
    this.isValid = 1
    this.doKeyChange()
  }

  private setDeleteKey (key: string) {
    this.deleteKey = key
    this.showDeleteModal = true
  }

  private doDelete () {
    if (this.deleteKey === 'apiKey') {
      this.deleteApiKey()
    } else {
      this.doDeleteImg()
    }
    this.showDeleteModal = false
  }

  /* Apiキー削除 */
  private deleteApiKey () {
    this.isValid = 0
    this.doKeyChange()
  }

  /* 作成日整形 */
  private displayApiKeyDate (keyDate: any) {
    if (keyDate !== null && keyDate !== undefined) {
      let year = keyDate.slice(0, 4)
      let month = keyDate.slice(5, 7)
      let date = keyDate.slice(8, 10)
      return year + '年' + month + '月' + date + '日'
    }
  }

  private async doPasswordEdit () {
    if (!this.isPasswordEdit()) {
      this.alertText = ''
      this.show400ModalErrorMessage = true
      return
    }

    /* API側修正完了後に対応 */
    const bodyData: any = {
      'password': this.currentPassword,
      'new_password': this.newPassword
    }

    const result = await MypagePasswordApi.doMypagePasswordResetting(bodyData)
    if (result.isOk()) {
      /* モーダル閉じる前に入力値をクリア */
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmNewPassword = ''

      this.showEditModal = false
      // 完了アラート表示
      Vue.prototype.$alert.toast({ text: 'パスワードを変更しました。', type: 0 })
      this.show400ModalErrorMessage = false
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      this.alertText = errorData.alertText
      this.alertTitle = errorData.alertTitle
      this.show400ModalErrorMessage = true
    }
  }

  private isPasswordEdit () {
    // リセット
    this.errorMessages = {}

    let currentPasswordFlag = Validator.validateInputPassword('CurrentPasswordMessage', this.currentPassword)
    let newPasswordFlag = Validator.validateInputPassword('NewPasswordErrorMessage', this.newPassword)
    let confirmNewPasswordFlag = Validator.validateInputConfirmPassword('confirmPasswordErrorMessage', this.confirmNewPassword)

    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    /* 新しいパスワード入力チェック */
    if (newPasswordFlag && confirmNewPasswordFlag) {
      if (this.newPassword === this.confirmNewPassword) {
        newPasswordFlag = true
        confirmNewPasswordFlag = true
      } else {
        this.$set(this.errorMessages, 'confirmPasswordErrorMessage', '入力内容が「新しいパスワード」と一致しません。')
        newPasswordFlag = false
        confirmNewPasswordFlag = false
      }
    }

    return currentPasswordFlag && newPasswordFlag && confirmNewPasswordFlag
  }

  private closeEditModal () {
    /* モーダル閉じる前に入力値をクリア */
    this.currentPassword = ''
    this.newPassword = ''
    this.confirmNewPassword = ''
    this.errorMessages = {}

    this.showEditModal = false
  }

  /* APIキー取得API */
  private getApiKeyData () {
    (async () => {
      const result = await MypageGetKeyApi.getKeyData()

      if (result.isOk()) {
        this.keyData = result.getPayload()
        this.$store.commit('setFlagState/setMyApiKeyFlag', false)

        if (this.keyData.api_key === '') {
          this.showApiKey = false
        } else {
          this.showApiKey = true
          this.apiKey = this.keyData.api_key
          this.apiKeyDate = this.displayApiKeyDate(this.keyData.create_date)
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  // 画像
  private onImageUploaded (e: any) {
    this.file = e.target.files[0]
    if (e.target.files[0].type === 'image/png' ||
        e.target.files[0].type === 'image/jpeg') {
      if (this.file !== undefined) {
        this.uploadImg(this.file)
      }
    } else {
      // 完了アラート表示
      Vue.prototype.$alert.toast({ text: '許可されている拡張子ではありません。（登録できる拡張子は、.jpeg、.jpg、.pngです）', type: 1 })
    }
  }

  private async getDefaultImg () {
    this.showLinkImgLoading = true
    const result = await GetLinkImgApi.getLinkImgData()
    // resultがオブジェクト型の場合、エラーで画像が存在しないため「登録なし」を表示
    if (typeof result === 'object') {
      this.isLinkImg = false
    } else {
      this.linkImg = String(result)
      this.isLinkImg = true
    }
    this.showLinkImgLoading = false
  }

  private async uploadImg (data: any) {
    this.$emit('show-loading')
    const result = await UploadLinkImgApi.uploadLinkImg(data)

    if (result.isOk()) {
      this.getDefaultImg()
      // 完了アラート表示
      Vue.prototype.$alert.toast({ text: '作付け関連リンクアイコンを変更しました。', type: 0 })
    } else if (result.getPayload().status_code === '400') {
      // バリデーションエラー(alert表示)
      let errors: any = []
      for (var i in result.getPayload().errors) {
        if (result.getPayload().errors[i].code === '29003EV008') {
          errors.push(result.getPayload().errors[i].message + '（登録できる拡張子は、.jpeg、.jpg、.pngです）')
        } else {
          errors.push(result.getPayload().errors[i].message)
        }
      }
      const alertText = errors.join('\n')
      Vue.prototype.$alert.toast({ text: alertText, type: 1 })
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'alert')
    }
    this.$emit('show-loading')
  }

  private async doDeleteImg () {
    this.$emit('show-loading')
    const result = await LinkImgDeleteApi.doLinkImgDelete()

    if (result.isOk()) {
      this.getDefaultImg()
      // 完了アラート表示
      Vue.prototype.$alert.toast({ text: '作付け関連リンクアイコンを削除しました。', type: 0 })
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'alert')
    }
    this.$emit('show-loading')
  }

  /* APIキー更新API */
  private async doKeyChange () {
    this.$store.commit('setFlagState/setMyApiKeyFlag', true)
    this.$emit('show-loading')

    const bodyData: any = {
      'is_valid': this.isValid
    }

    const result = await MypagePutKeyApi.doKeyChange(bodyData)
    if (result.isOk()) {
      this.keyData = result.getPayload()
      this.$store.commit('setFlagState/setMyApiKeyFlag', false)

      if (this.keyData.api_key === '') {
        this.showApiKey = false
        // 完了アラート表示
        Vue.prototype.$alert.toast({ text: '外部APIキーを削除しました。', type: 0 })
      } else {
        this.showApiKey = true
        this.apiKey = this.keyData.api_key
        this.apiKeyDate = this.displayApiKeyDate(this.keyData.create_date)
        // 完了アラート表示
        Vue.prototype.$alert.toast({ text: '外部APIキーを更新しました。', type: 0 })
      }
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'alert')
    }
    this.$emit('show-loading')
  }

  /* サービス機能設定取得API */
  private getServiceFunctionData () {
    (async () => {
      const result = await ServiceFunctionApi.getServiceFunctionData()
      if (result.isOk()) {
        const serviceFunctionValue = result.getPayload()
        // ローカルストレージのサービス機能設定を削除
        if (localStorage['serviceFunctionValue'] !== undefined) {
          await localStorage.removeItem('serviceFunctionValue')
        }
        // セット
        await Local.setServicdeFunctionValue(JSON.stringify(serviceFunctionValue))
        this.serviceFunctionData.news_board.news_board_name = serviceFunctionValue.news_board.news_board_name
        this.serviceFunctionData.external_link.external_link_name = serviceFunctionValue.external_link.external_link_name
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  /* サービス機能設定更新API */
  private async doServiceFunctionEdit () {
    /* バリデーションチェック */
    if (!this.isServiceFunctionEdit()) {
      return
    }
    this.$emit('show-loading')

    const bodyData: any = {
      'news_board': this.serviceFunctionData.news_board,
      'external_link': this.serviceFunctionData.external_link
    }

    /* APIリクエスト */
    const result = await ServiceFunctionEditApi.doServiceFunctionEdit(bodyData)
    if (result.isOk()) {
      // 完了アラート表示
      Vue.prototype.$alert.toast({ text: '機能設定を変更しました。', type: 0 })
      // サービス機能設定値を再取得しローカルストレージにセット
      await CommonClass.setServiceFunctionData('pc')
    } else if (result.getPayload().status_code === '400') {
      // バリデーションエラー(alert表示)
      let errors: any = []
      for (var i in result.getPayload().errors) {
        errors.push(result.getPayload().errors[i].message)
      }
      const alertText = errors.join('\n')
      Vue.prototype.$alert.toast({ text: alertText, type: 1 })
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'alert')
    }
    this.$emit('show-loading')
  }

  private isServiceFunctionEdit () {
    const isNewsBoardError = Validator.validateInputNewsBoardName('NewsBoardNameErrorMessage', this.serviceFunctionData.news_board.news_board_name)
    const isExternalLinkError = Validator.validateInputExternalLinkName('ExternalLinkNameErrorMessage', this.serviceFunctionData.external_link.external_link_name)
    this.errorMessages = Validator.getErrorMessage()
    return isNewsBoardError && isExternalLinkError
  }
}
